import { useMemo } from "react"

type LocalStorageResponse = {
  response: 'notNow' | 'continue'
  expiration: number
}

const RESPONSE_EXPIRATION_TIME_IN_MS = 96 * 60 * 60 * 1000 // 96 hours
export const STORAGE_KEY_MOBILE_APP_POPUP_RESPONSE = 'mobileAppPopupResponse'

export const saveLTMobileAppPromoUserResponse = (response: 'notNow' | 'continue') => {
  const now = new Date().getTime()
  const expirationTime = now + RESPONSE_EXPIRATION_TIME_IN_MS
  const userResponseData: LocalStorageResponse = {
    response,
    expiration: expirationTime
  }
  localStorage.setItem(STORAGE_KEY_MOBILE_APP_POPUP_RESPONSE, JSON.stringify(userResponseData))
}

export function useCheckLTMobileAppPromoLocalStorageResponse() {
  return useMemo(() => {
    const existingResponse = localStorage.getItem(STORAGE_KEY_MOBILE_APP_POPUP_RESPONSE)

    if (!existingResponse) {
      return null
    }

    const parsedResponse: LocalStorageResponse = JSON.parse(existingResponse)
    const now = new Date().getTime()

    if (parsedResponse.expiration > now) {
      return parsedResponse.response
    }

    localStorage.removeItem(STORAGE_KEY_MOBILE_APP_POPUP_RESPONSE)
    return null
  }, [])
}